import {
    CUSTOMER_SUPPORT_EMAIL,
    CORPORATE_SITEURL,
    SERVICE_SITEURL,
    SITENAME,
    SUPPORT_DESK_SITEURL,
    LP_SITE_URL,
    LEAD_SITE_URL
} from '@/constants';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/router';
import store from '@/store/store';
import '@/directives';
import '@/filters';
import '@/plugins';
import '@/assets/css/style.scss';

Vue.prototype.$constants = {
    customerSupportEmail: CUSTOMER_SUPPORT_EMAIL,
    corporateSiteUrl: CORPORATE_SITEURL,
    serviceSiteUrl: SERVICE_SITEURL,
    siteName: SITENAME,
    supportDeskSiteUrl: SUPPORT_DESK_SITEURL,
    lpSiteUrl: LP_SITE_URL,
    leadSiteUrl: LEAD_SITE_URL
};
if (process.env.VUE_APP_ENV === 'demo') {
    Vue.prototype.$constants.isDemo = true;
}
Vue.config.keyCodes.backspace = 8;
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
